/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery = {
  readonly __typename?: 'Query';
  readonly privateOfferings?: {
    readonly __typename?: 'PrivateOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly type: Types.OfferingType;
      readonly orderBookConfiguration?: {
        readonly __typename?: 'OrderBookConfigurationFull';
        readonly isLimitIndicationsOnlyEnabled: boolean;
        readonly isOnlySharesUnitOnIndicationsEnabled: boolean;
        readonly isIndicationPriceAsPercentageParEnabled: boolean;
      } | null;
    }> | null;
  } | null;
};

export type OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationVariables =
  Types.Exact<{
    input: Types.UpdateOrderBookConfigurationInput;
  }>;

export type OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation = {
  readonly __typename?: 'Mutation';
  readonly updateOrderBookConfiguration?: {
    readonly __typename?: 'UpdateOrderBookConfigurationPayload';
    readonly offering?: {
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly orderBookConfiguration?: {
        readonly __typename?: 'OrderBookConfigurationFull';
        readonly isLimitIndicationsOnlyEnabled: boolean;
        readonly isOnlySharesUnitOnIndicationsEnabled: boolean;
        readonly isIndicationPriceAsPercentageParEnabled: boolean;
      } | null;
    } | null;
  } | null;
};

export const OfferingSetup_ConfigurationRoute_OrderBookConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OfferingSetup_ConfigurationRoute_OrderBookConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderBookConfiguration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLimitIndicationsOnlyEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isOnlySharesUnitOnIndicationsEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isIndicationPriceAsPercentageParEnabled',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery__
 *
 * To run a query within a React component, call `useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
  > &
    (
      | {
          variables: OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
  >(OfferingSetup_ConfigurationRoute_OrderBookConfigurationDocument, options);
}
export function useOfferingSetup_ConfigurationRoute_OrderBookConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
  >(OfferingSetup_ConfigurationRoute_OrderBookConfigurationDocument, options);
}
// @ts-ignore
export function useOfferingSetup_ConfigurationRoute_OrderBookConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
  OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
>;
export function useOfferingSetup_ConfigurationRoute_OrderBookConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
        OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery | undefined,
  OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
>;
export function useOfferingSetup_ConfigurationRoute_OrderBookConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
        OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
  >(OfferingSetup_ConfigurationRoute_OrderBookConfigurationDocument, options);
}
export type OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryHookResult = ReturnType<
  typeof useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery
>;
export type OfferingSetup_ConfigurationRoute_OrderBookConfigurationLazyQueryHookResult = ReturnType<
  typeof useOfferingSetup_ConfigurationRoute_OrderBookConfigurationLazyQuery
>;
export type OfferingSetup_ConfigurationRoute_OrderBookConfigurationSuspenseQueryHookResult =
  ReturnType<typeof useOfferingSetup_ConfigurationRoute_OrderBookConfigurationSuspenseQuery>;
export type OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryResult = Apollo.QueryResult<
  OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery,
  OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables
>;
export const OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'OfferingSetup_ConfigurationRoute_UpdateOrderBookConfiguration',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOrderBookConfigurationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrderBookConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'offering' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderBookConfiguration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLimitIndicationsOnlyEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isOnlySharesUnitOnIndicationsEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isIndicationPriceAsPercentageParEnabled',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationFn =
  Apollo.MutationFunction<
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation,
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationVariables
  >;

/**
 * __useOfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation__
 *
 * To run a mutation, you first call `useOfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offeringSetupConfigurationRouteUpdateOrderBookConfigurationMutation, { data, loading, error }] = useOfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation,
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation,
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationVariables
  >(OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationDocument, options);
}
export type OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationHookResult =
  ReturnType<typeof useOfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation>;
export type OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationResult =
  Apollo.MutationResult<OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation>;
export type OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutation,
    OfferingSetup_ConfigurationRoute_UpdateOrderBookConfigurationMutationVariables
  >;

import { makeMockResponse } from '../../../../../graphql/mock-response';

export const makeOfferingSetup_ConfigurationRoute_OrderBookConfigurationMockResponse =
  makeMockResponse<
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQueryVariables,
    OfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery
  >(OfferingSetup_ConfigurationRoute_OrderBookConfigurationDocument);
